import Home from '@merchant-backend/support-center/src/views/Home'
import List from '@merchant-backend/support-center/src/views/List'
import Detail from '@merchant-backend/support-center/src/views/Detail'
import Search from '@merchant-backend/support-center/src/views/SearchResult'

export default [
  {
    path: 'home',
    components: Home
  },
  {
    path: 'list/:cid',
    components: List
  },
  {
    path: 'detail/:id',
    components: Detail
  },
  {
    path: 'result',
    components: Search
  }
]
